import React, { useCallback } from "react";
import { useOffer } from "../../../../hooks/offer";
import { CustomButtom } from "../../../../components/BotaoCTA/styles";
import * as S from "./style";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import { eventTrack } from "src/components/GoogleTagManager";
import { slugfy } from "src/utils/formatters";

export default function Banner() {
  const { currentOffer } = useOffer();
  const { data, isLoading } = useFetchContent();

  const scrollToOffer = useCallback(() => {
    const el = document.querySelector("#plans");
    const yOffset = -120;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  if (isLoading || !data) return <Loading />;

  const {
    mensagemBanner,
    bannerMessageColor,
    bannerTitleColor,
    landingTitulo,
    backgroundImagem,
    PrimaryButtonText,
    primaryColorButton,
    primaryButtonTextColor,
    secondaryButtonColor,
    secondaryButtonTextColor,
    secondaryButtonText,
    secondaryBtnBorder,
    hasPrimmaryBtn,
    hasSecondaryBtn,
  } = getSection({ sectionName: "landingHeader", data });
  const bannerBgImage = backgroundImagem.fields.file.url;

  const openLink = () => {
    window.open("https://veloe.com.br/sobre", "_blank").focus();
  };

  return (
    <S.Container>
      <S.Content>
        {currentOffer && currentOffer.intro ? (
          <S.TextIntro
            cor={bannerMessageColor}
            tamanho="Grande"
            dangerouslySetInnerHTML={{ __html: currentOffer.intro }}
          />
        ) : (
          <S.TextIntro cor={bannerMessageColor}>{mensagemBanner}</S.TextIntro>
        )}
        <S.Title tamanho="Medio" cor={bannerTitleColor}>
          {currentOffer && currentOffer.title
            ? currentOffer.title
            : landingTitulo}
        </S.Title>
        <div>
          {hasPrimmaryBtn === true && (
            <S.ContainerCTA>
              <CustomButtom
                color="primary"
                label={PrimaryButtonText}
                onBg="light"
                onClick={() => {
                  scrollToOffer();
                  eventTrack(
                    "veloe:institucional",
                    "clique:botao",
                    "banner:" + slugfy(PrimaryButtonText)
                  );
                }}
                style={{
                  color: primaryButtonTextColor,
                  backgroundColor: primaryColorButton,
                  border: undefined,
                }}
              />
            </S.ContainerCTA>
          )}
          {hasSecondaryBtn === true && (
            <S.ContainerCTA>
              <CustomButtom
                color="primary"
                label={secondaryButtonText}
                onBg="light"
                onClick={openLink}
                style={{
                  backgroundColor: secondaryButtonColor,
                  color: secondaryButtonTextColor,
                  border: `1px solid ${secondaryBtnBorder}`,
                }}
              />
            </S.ContainerCTA>
          )}
        </div>
      </S.Content>
      <S.BackgroundImage
        src="/bradescoprime/assets/conjunto-tags-bradescoprime.svg"
        alt="Conjunto de tags Veloe Bradesco Prime"
      />
    </S.Container>
  );
}
